import { useState } from "react";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import ChecklistRoundedIcon from "@mui/icons-material/ChecklistRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

const MenuPage = (props) => {
  const samplePreset = [
    {
      presetName: "Productivity Sprint",
      totalTime: "70min",
      author: "N/A",
      description:
        "Clean Workspace:10,Organize pantry:15,Write weekly affirmations:15,Do a quick workout:20",

      presetTasks: [
        {
          taskName: "Clean Workspace",
          estimatedTaskTime: 15,
        },
        {
          taskName: "Organize pantry",
          estimatedTaskTime: 20,
        },
        {
          taskName: "Write weekly affirmations",
          estimatedTaskTime: 15,
        },
        {
          taskName: "Do a quick workout",
          estimatedTaskTime: 20,
        },
      ],
    },
    {
      presetName: "Mind Refresh",
      totalTime: "65min",
      author: "NA",
      description:
        "Practice light stretches:5,Organize a small section of your workspace:8,Sketch or doodle something relaxing:10,Write down three positive thoughts or affirmations:10,Listen to a short guided relaxation audio:15,Clean and arrange your desk supplies:8,Flip through a book or magazine for inspiration:10,Practice a quick breathing exercise:5",
      presetTasks: [
        {
          taskName: "Practice light desk stretches",
          estimatedTaskTime: 5,
        },
        {
          taskName: "Organize a small section of your workspace",
          estimatedTaskTime: 8,
        },
        {
          taskName: "Sketch or doodle something relaxing",
          estimatedTaskTime: 10,
        },
        {
          taskName: "Write down three positive thoughts or affirmations",
          estimatedTaskTime: 10,
        },
        {
          taskName: "Listen to a short guided relaxation audio",
          estimatedTaskTime: 15,
        },
        {
          taskName: "Clean and arrange your desk supplies",
          estimatedTaskTime: 8,
        },
        {
          taskName: "Flip through a book or magazine for inspiration",
          estimatedTaskTime: 10,
        },
        {
          taskName: "Practice a quick breathing exercise",
          estimatedTaskTime: 5,
        },
      ],
    },
    // {
    //   name: "Personal Growth Review",
    //   author: "Team abc",
    //   totalTime: "55min",
    //   description:
    //     "Write strengths and weaknesses:15,Review recent achievements:20,Identify areas to improve:20",
    // },
  ];

  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="preset-list">
      <div className="preset-list-grid">
        {samplePreset.map((preset, index) => (
          <article
            key={preset.presetName}
            className={`preset-card ${
              expandedIndex === index ? "preset-card-expanded" : ""
            }`}
          >
            <div className="preset-card-main">
              <span className="preset-card-icon">
                <RocketLaunchIcon />
              </span>

              <div className="preset-card-summary">
                <h3 className="preset-card-title">
                  {preset.presetName}
                </h3>

                <div className="preset-card-meta">
                  <span>
                    <ChecklistRoundedIcon />
                    {preset.presetTasks.length}
                  </span>
                  <span>
                    <AccessTimeRoundedIcon />
                    {preset.presetTasks.reduce(
                      (total, task) => total + task.estimatedTaskTime,
                      0
                    )}{" "}
                    min
                  </span>
                </div>
              </div>

              <div className="preset-card-actions">
                <button
                  onClick={() => handleToggle(index)}
                  className="preset-details-button"
                  aria-expanded={expandedIndex === index}
                  aria-label={
                    expandedIndex === index
                      ? `Hide ${preset.presetName} details`
                      : `Show ${preset.presetName} details`
                  }
                >
                  <VisibilityIcon />
                  <ExpandMoreRoundedIcon
                    className={`preset-expand-icon ${
                      expandedIndex === index ? "is-open" : ""
                    }`}
                  />
                </button>

                <button
                  onClick={() => {
                    props.addTasksToList(preset);
                    props.setIsMenuOn(false);
                  }}
                  className="preset-use-button"
                >
                  <RocketLaunchIcon />
                  <span>Use</span>
                </button>
              </div>
            </div>

            <div
              className={`preset-details ${
                expandedIndex === index ? "is-open" : ""
              }`}
            >
              <div className="preset-details-inner">
                <div className="preset-task-heading">
                  <span>Included tasks</span>
                  <span>Duration</span>
                </div>
                {preset.presetTasks.map((task, taskIndex) => (
                  <div className="preset-task-row" key={task.taskName}>
                    <span className="preset-task-name">
                      <span className="preset-task-number">
                        {taskIndex + 1}
                      </span>
                      {task.taskName}
                    </span>
                    <span className="preset-task-time">
                      {task.estimatedTaskTime} min
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default MenuPage;
